import React from 'react';
import { createPlugin } from 'react-plugin';
import { ControlPanel } from './ControlPanel.js';
const { namedPlug, register } = createPlugin({
    name: 'controlPanel',
    defaultConfig: {
        controlActionOrder: [],
    },
});
namedPlug('sidePanelRow', 'values', ({ pluginContext, slotProps }) => {
    const { controlActionOrder } = pluginContext.getConfig();
    const { fixtureState, onFixtureStateChange } = slotProps;
    return (React.createElement(ControlPanel, { fixtureState: fixtureState, controlActionOrder: controlActionOrder, onFixtureStateChange: onFixtureStateChange }));
});
export { register };
if (process.env.NODE_ENV !== 'test')
    register();
